import {
  useDeleteDocumentBookmarked,
  useGetNewTalkFlowList,
  useSetDocumentBookmarked,
} from '@/hooks/apiHooks';
import { INIT_TALK_FLOW_BOOKMARK_COUNT_PARAMS } from '@/recoil/init_data';
import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { documentFilterState } from '@/recoil/atom';
import { t } from 'i18next';
import { useSnackbar } from '@/hooks/global-tools';

const useDocumentsData = () => {
  const filters = useAtomValue(documentFilterState);

  const { internalParticipants, ...restFilters } = filters;

  const params: any = {
    ...restFilters,
    createdBy: filters.createdBy.map((res) => res.passportId),
    documentTypes: filters.documentTypes.join(','),
  };

  if (internalParticipants.length > 0) {
    params.internalParticipants = internalParticipants
      .map((res) => res.passportId)
      .join(',');
  }

  const {
    data,
    isLoading,
    mutate: contentMutate,
  } = useGetNewTalkFlowList(params);

  const { data: bookmarkData, mutate: bookMarkMutate } = useGetNewTalkFlowList(
    INIT_TALK_FLOW_BOOKMARK_COUNT_PARAMS,
  );

  const bookMarkCount =
    bookmarkData?.meta.totalCount && bookmarkData?.meta.totalCount > 0
      ? bookmarkData?.meta.totalCount
      : undefined;

  const [disabled, setDisabled] = useState(false);

  const toast = useSnackbar();

  const handleBookmark = async (docId: string, isBookmarked: boolean) => {
    try {
      setDisabled(true);
      await (isBookmarked
        ? useDeleteDocumentBookmarked(docId)
        : useSetDocumentBookmarked(docId));

      contentMutate((currentData: any) => {
        if (!currentData) return currentData;
        return {
          ...currentData,
          data: currentData.data.map((item: any) => {
            if (item.id === docId) {
              return { ...item, isBookmarked: !item.isBookmarked };
            }
            return item;
          }),
        };
      }, false);
      !isBookmarked &&
        toast.showSuccess({ message: t('즐겨찾기에 추가되었습니다.') });
    } catch {
      // 북마크 토글 실패는 무시 — finally 의 재검증(bookMarkMutate)이 실제 상태로 되돌린다.
    } finally {
      await bookMarkMutate();
      setDisabled(false);
    }
  };

  return {
    bookMarkCount,
    handleBookmark,
    contentMutate,
    data,
    isLoading,
    disabled,
  };
};

export default useDocumentsData;
